import React, {useState, useEffect } from 'react';
import { 
         Grid,
         LinearProgress,
         Paper,
        } from '@material-ui/core';
import { 
    LoadingOutlined as LoadingOutlinedIcon,
    ReloadOutlined as ReloadOutlinedIcon
   } from '@ant-design/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import { 
    Button as ButtonAntd,
    Popconfirm,
} from 'antd';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';


function OT_ADD(){
    const { authTokens } = useAuth(); 
    const { enqueueSnackbar} = useSnackbar();
    const [ isDownImage, setDownImage ] = useState(false);
    const [ isRebooting, setRebooting ] = useState(false);

    

    useEffect(
        ()=>{  
            let intervalId = setInterval(reloadW,10000)
            return(() => {
                clearInterval(intervalId)
            })
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(isDownImage){
            setTimeout(()=>{
                setDownImage(false);
            },1000)
            
        }
    },[isDownImage])

    const reloadW = ()=>{
        setDownImage(true);
    };

    const handleReloadW = ()=>{
        
        setRebooting(true);
        fetch('/api/WhatsappReboot',{
            method:'POST',
            body: JSON.stringify({Empresa:authTokens.Empresa}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setRebooting(false);
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'})
            }else{
                console.log(result)
                enqueueSnackbar(`ERROR DEL SISTEMA`, {variant:'error'})
            }
            
        })
    }

    return(
        <Grid container spacing={2} justifyContent='center' style={{padding:5}}>
            <Grid item  md={6} sm={10} xs={12}>
                <Paper elevation={3} style={{padding:15, width:'100%', minHeight:200}}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={12} style={{height:5}}>
                            {isRebooting &&  <LinearProgress color='secondary' /> }
                            {isDownImage &&  <LinearProgress color='primary' /> }
                        </Grid>
                        <Grid item xs={10}>            
                            <Popconfirm
                                title="DESEA REINICIAR EL WHATSAPP?"
                                onConfirm={handleReloadW}
                                okText="SI"
                                cancelText="NO"
                            >
                                <ButtonAntd 
                                    block 
                                    icon={isRebooting ? <LoadingOutlinedIcon/> :<ReloadOutlinedIcon/>}
                                    size='large'  
                                    type="primary" 
                                    disabled={isRebooting}                            
                                >
                                    REINICIAR
                                </ButtonAntd>
                            </Popconfirm>
                        </Grid> 
                       
                        <Grid item xs={8}>
                            {isDownImage 
                            ? <Grid container justifyContent='center' alignItems='center'>
                                <Grid item>
                                    < FacebookCircularProgress size={35} />
                                </Grid>
                            </Grid>
                            : <img src='wqr/qr.svg' width='100%' alt='WHATSAPP' key={Date.now()}/>
                            }
                        </Grid>
                    </Grid>   
                </Paper>
            </Grid>
            
        </Grid>
    );
};

function ADD_OT(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <OT_ADD />
        </SnackbarProvider>
    );
};

export default ADD_OT;